import {  Typography } from '@/components';

export function MyOpportunitiesHeader() {
  return (
    <div>
      <Typography as="h1" size="heading-2" weight="semibold" className="mb-2">
        Seller Dashboard
      </Typography>
    </div>
  );
}
